import {BOT_LINK} from "../model/const.js";
import styles from './postBuyContent.module.css'
export default function PostBuyContent() {
    return (
        <section className="container-custom d-flex align-items-center flex-column gap-5">
            <p className={`${styles.text}`}>
                Вы успешно вступили в партию!
                <br/>
                <br/>
                следите за развитием событий в личном кабинете или через Telegram-бот.
            </p>
            <a
                className="btn btn-red-filled"
                href={BOT_LINK}
                target="_blank"
                rel="noopener noreferrer"
            >
                перейти в бот
            </a>
        </section>
    )
}